import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var LightOn = createIcon({
  displayName: 'LightOn',
  viewBox: '0 0 24 24',
  path: [/*#__PURE__*/_jsx("path", {
    d: "M12,8a3.75,3.75,0,0,1,4,4c0,2.54-2.68,5.27-2.71,5.29l-.29.3V19H11V17.59l-.29-.3S8,14.54,8,12a3.75,3.75,0,0,1,4-4m0-1a4.72,4.72,0,0,0-5,5c0,3,3,6,3,6v1.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V18s3-3,3-6a4.72,4.72,0,0,0-5-5Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.5,21h-3a.5.5,0,0,0,0,1h3a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12,3a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,1,0v-2A.5.5,0,0,0,12,3Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19.21,5.29a.51.51,0,0,0-.36.15L17.44,6.85a.5.5,0,0,0,0,.71.49.49,0,0,0,.35.15.51.51,0,0,0,.36-.15l1.41-1.41a.5.5,0,0,0,0-.71.49.49,0,0,0-.35-.15Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.79,5.29a.49.49,0,0,0-.35.15.5.5,0,0,0,0,.71L5.85,7.56a.51.51,0,0,0,.36.15.49.49,0,0,0,.35-.15.5.5,0,0,0,0-.71L5.15,5.44a.51.51,0,0,0-.36-.15Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M20.5,11.5h-2a.5.5,0,0,0,0,1h2a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.79,16.29a.49.49,0,0,0-.35.15.5.5,0,0,0,0,.71l1.41,1.41a.51.51,0,0,0,.36.15.49.49,0,0,0,.35-.15.5.5,0,0,0,0-.71l-1.41-1.41a.51.51,0,0,0-.36-.15Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5.5,11.5h-2a.5.5,0,0,0,0,1h2a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6.21,16.29a.51.51,0,0,0-.36.15L4.44,17.85a.5.5,0,0,0,0,.71.49.49,0,0,0,.35.15.51.51,0,0,0,.36-.15l1.41-1.41a.5.5,0,0,0,0-.71.49.49,0,0,0-.35-.15Z"
  })]
});
//# sourceMappingURL=LightOn.js.map